import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { observer } from "mobx-react";
import React, { useCallback, useEffect } from "react";
import { Avatar, Card, Form, PluginUpdateEmbed, Space, useStores as useRpmStores } from "@devowl-wp/real-product-manager-wp-client";
import { i18n, rmlOpts } from "../../util/index.js";
const ConfigLicensingConsumer = observer(({ withinModal = false, onClose })=>{
    const { pluginUpdateStore: { pluginUpdates } } = useRpmStores();
    const { slug, others: { isPro, showLicenseFormImmediate }, publicUrl } = rmlOpts;
    const pluginUpdate = pluginUpdates.get(slug);
    const handleLicenseUpdated = useCallback(()=>{
        // When form is shown directly after first usage, return to dashboard
        rmlOpts.others.showLicenseFormImmediate = false;
        onClose?.();
    }, []);
    const handleLicenseSkip = useCallback(()=>{
        rmlOpts.others.showLicenseFormImmediate = false;
        pluginUpdate.skip();
        onClose?.();
    }, [
        pluginUpdate
    ]);
    // Automatically skip if form already interacted (e.g. browser back cache issue)
    useEffect(()=>{
        if (showLicenseFormImmediate && pluginUpdate?.hasInteractedWithFormOnce) {
            handleLicenseSkip();
        }
    }, [
        pluginUpdate,
        showLicenseFormImmediate,
        handleLicenseSkip
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            showLicenseFormImmediate && /*#__PURE__*/ _jsxs("div", {
                style: {
                    maxWidth: 650,
                    textAlign: "center",
                    margin: "0 auto"
                },
                children: [
                    !withinModal && /*#__PURE__*/ _jsx(Avatar, {
                        src: `${publicUrl}images/logos/real-media-library.svg`,
                        shape: "square",
                        size: 130,
                        style: {
                            backgroundColor: "white",
                            padding: 25,
                            borderRadius: 999,
                            marginBottom: 10
                        }
                    }),
                    !withinModal && !isPro && /*#__PURE__*/ _jsx("p", {
                        style: {
                            fontSize: 15,
                            margin: "0 auto 20px"
                        },
                        children: i18n("licenseFreeDescription")
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Card, {
                title: withinModal || !pluginUpdate ? undefined : isPro || pluginUpdate.isLicensed ? i18n("licenseActivation") : i18n("licenseGetFreeActivation"),
                bordered: !withinModal,
                children: /*#__PURE__*/ _jsxs(Space, {
                    direction: "vertical",
                    size: "large",
                    children: [
                        withinModal && !isPro && /*#__PURE__*/ _jsx("p", {
                            className: "description",
                            style: {
                                fontWeight: "bold"
                            },
                            children: i18n("licenseFreeDescription")
                        }),
                        /*#__PURE__*/ _jsx(PluginUpdateEmbed, {
                            formProps: {
                                onSave: handleLicenseUpdated,
                                // Skip remote errors and move to dashboard immediately
                                onFailure: showLicenseFormImmediate && !isPro ? handleLicenseSkip : undefined,
                                footer: /*#__PURE__*/ _jsx(Form.Item, {
                                    style: {
                                        margin: "25px 0 0",
                                        textAlign: showLicenseFormImmediate ? "center" : undefined
                                    },
                                    children: /*#__PURE__*/ _jsx("button", {
                                        type: "submit",
                                        className: "button button-primary",
                                        children: showLicenseFormImmediate ? isPro ? i18n("licenseActivationBtnPro") : i18n("licenseActivationBtnFree") : i18n("save")
                                    })
                                })
                            },
                            listProps: {
                                onDeactivate: handleLicenseUpdated
                            },
                            slug: slug
                        })
                    ]
                })
            }),
            pluginUpdate && showLicenseFormImmediate && /*#__PURE__*/ _jsx("div", {
                style: {
                    textAlign: "center",
                    marginBottom: 20,
                    marginTop: withinModal ? 24 : 20
                },
                children: /*#__PURE__*/ _jsx("a", {
                    className: "button-link",
                    onClick: handleLicenseSkip,
                    children: isPro ? i18n("licenseActivationSkipPro") : i18n("licenseActivationSkipFree")
                })
            })
        ]
    });
});
export { ConfigLicensingConsumer };
